
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/technology",
      function () {
        return require("private-next-pages/technology/index.js");
      }
    ]);
  